<template>
  <base-card class="hover:tw-bg-gray-50 tw-cursor-pointer" :noPadding="true">
    <div class="tw-h-full tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" @click="$emit('cardClicked')">
      <h3 class="tw-text-gray-700 tw-font-thin tw-text-lg tw-whitespace-nowrap">{{ title }}</h3>
      <div v-if="isLoading" class="tw-flex tw-flex-col tw-mt-1">
        <base-skeleton-loader class="tw-h-5 tw-w-12" />
        <base-skeleton-loader class="tw-h-3 tw-w-8 tw-mt-3.5" />
      </div>
      <div v-else>
        <div class="tw-flex tw-flex-col">
          <div class="tw-text-gray-800 tw-text-lg tw-font-medium ">{{ count.toLocaleString() }}</div>
          <div v-if="changeCount" class="tw-flex tw-mt-2">
            <component
              :is="component"
              :class="[changeCount > 0 ? 'tw-text-green-600 tw--rotate-90' : 'tw-text-red-600 tw-rotate-90']"
              class="tw-h-4 tw-w-4 tw-transform tw-my-auto tw--ml-1"
            ></component>
            <div :class="[changeCount > 0 ? 'tw-text-green-600' : 'tw-text-red-600']" class="tw-text-sm">{{ Math.abs(changeCount).toLocaleString() + changeLabel }}</div>
          </div>
        </div>
      </div>
    </div>
  </base-card>
</template>
<script>
export default {
  name: "SummaryCount",
  components: {
    ArrowRightIcon: () => import("@/assets/svgs/arrow-right-icon.svg"),
    XIcon: () => import("@/assets/svgs/x-icon.svg"),
  },
  computed: {
    component() {
      if (this.icon === "arrow-right") return "ArrowRightIcon";
      if (this.icon === "x") return "XIcon";

      return "ArrowRightIcon";
    },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
    changeCount: {
      type: Number,
      default: 0,
    },
    changeLabel: {
      type: String,
      default: " this week",
    },
    icon: {
      type: String,
      default: "arrow-right",
    },
  },
};
</script>
